import { IncidentWorkflow } from "@/components/incidents/IncidentWorkflow";

export default function NewIncident() {
  return <IncidentWorkflow />;
}